module.exports = __webpack_public_path__ + "img/preview-1.1d48c645.webp";